import { isWeb } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropSolvedSupportRequests } from '~/navigation/Navigation.types';

import { SupportRequestItem } from '../SupportRequestItem';
import { SupportRequestList, SupportRequestListNative } from './SupportRequest.List';

export const SolvedSupportRequestsScreen = (props: ScreenPropSolvedSupportRequests) => {
  return (
    <PageContainer>
      <SolvedSupportRequestsLayout {...props} />
    </PageContainer>
  );
};

export const SolvedSupportRequestsLayout = (props: ScreenPropSolvedSupportRequests) => {
  const supportRequestId = props.route.params?.id;
  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(supportRequestId);
  }, [supportRequestId]);

  return (
    <ScreenTwoPageLayout>
      {isWeb ? (
        <SupportRequestList onPress={(item) => setId(item.id)} id={id} />
      ) : (
        <SupportRequestListNative />
      )}

      {id ? (
        <SupportRequestItem
          originScreen="SolvedSupportRequests"
          supportId={id}
          onClose={() => setId(undefined)}
        />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};
